import UserModal from "./UserModal";
import { enumUrl } from "../Utils/utils";
import Lang from "../Utils/lang";
import { deleteData } from "../Services/deleteData";
import { Typography } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";

let lang = Lang.getInstance();

function DeleteUser({
  setShowDeleteUserModal,
  setLoading,
  onGetUsers,
  userId,
  showDeleteUserModal,
}) {
  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  function closeModal() {
    setShowDeleteUserModal(false);
    setLoading(false);
  }
  const handleDeleteUser = () => {
    setLoading(true);
    let url = `${enumUrl.user}/${userId}`;
    deleteData(url)
      .then(async () => {
        await onGetUsers();
        closeModal();
        notifySuccess(lang.get("successDeleted"));
      })
      .catch((err) => {
        setLoading(false);
        notifyError(`${lang.get("errorDeletingData")}: ${err}`);
      });
  };

  return (
    <UserModal
      open={showDeleteUserModal}
      handleClose={closeModal}
      title={lang.get("deleteUser")}
      handleSubmit={handleDeleteUser}
      submitButton="Da"
      cancelButton="Nu"
    >
      <Typography style={{ margin: 10, padding: 10 }}>
        {lang.get("deleteItem")}
      </Typography>
      <ToastContainer />
    </UserModal>
  );
}

DeleteUser.propTypes = {
  setShowDeleteUserModal: PropTypes.func,
  setLoading: PropTypes.func,
  onGetUsers: PropTypes.func,
  userId: PropTypes.number,
  showDeleteUserModal: PropTypes.func,
};

export default DeleteUser;
